import { Box, Typography } from "@mui/material";
import React from "react";

export const BadgeBetaFeature = () => (
  <Box padding="3px 6px" borderRadius="8px" sx={{ backgroundColor: "rgba(35, 155, 139, 0.15)" }}>
    <Typography fontWeight={700} fontSize="11px" color="#187266">
      Beta
    </Typography>
  </Box>
);
